import { Component } from 'react';

import find from 'lodash/find';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import withGlobals from '../../withGlobals';
import Footer from '../Footer';
import NavBar from '../NavBar';

const propTypes = {
  isLoggedIn: PropTypes.bool,
};

const defaultProps = {
  isLoggedIn: false,
};

class LandingReferral extends Component {
  componentDidMount() {
    window.friendbuy = window.friendbuy || [];
    window.friendbuy.push([
      'widget',
      process.env.REACT_APP_FRIENDBUY_WIDGET_CODE,
    ]);
  }

  render() {
    const { isLoggedIn, oktaAccessToken, oktaIdToken } = this.props;
    return (
      <div className="ReferAFriend">
        <NavBar oktaAccessToken={oktaAccessToken} oktaIdToken={oktaIdToken} />
        <div
          className={`friendbuy-${process.env.REACT_APP_FRIENDBUY_WIDGET_CODE}`}
        />
        <Footer isLoggedIn={isLoggedIn} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isRentersAccount: !!find(state.policies, [
      'vertical.code',
      'farmers_renters',
    ]),
  };
};

LandingReferral.propTypes = propTypes;
LandingReferral.defaultProps = defaultProps;

const enhance = compose(withGlobals, connect(mapStateToProps));

export default enhance(LandingReferral);
